import * as React from 'react';
import { FormControl, Select as MuiSelect, InputBase, MenuItem } from '@mui/material';
import { css, StyleSheet } from 'aphrodite';
import { Colors } from '@lean-body/components/styles';
import { createStyles } from '@mui/material/styles';
import { styled } from '@mui/system';
import { ArrowIcon, ArrowDirection } from '@lean-body/components/atoms/icons/arrow_icon';
import { RequiredBadge } from './required_badge';
const { useState, useCallback, useEffect } = React;
const BootstrapInput = styled(InputBase)(() => createStyles({
    root: {
        width: '100%',
    },
    input: {
        padding: 14,
        border: `1px solid ${Colors.Gray}`,
        borderRadius: 4,
        backgroundColor: Colors.White,
        '&:focus': {
            borderRadius: 4,
            borderColor: Colors.Primary,
            boxShadow: `0 0 10px -5px ${Colors.Primary}`,
            backgroundColor: Colors.White,
        },
    },
}));
export const Select = ({ selectOptions, defaultValue, containerClassObject, selectClassObject, listClassObject, listItemClassObject, onChange, label, displayIcon, unitLabel, placeholder, placeholderValue, required, hasValidationError, validationErrorMessage, }) => {
    const [value, setValue] = useState(defaultValue);
    const [displayPlaceholder, setDisplayPlaceholder] = useState(getSetDisplayPlaceholder());
    useEffect(() => {
        setValue(defaultValue);
        setDisplayPlaceholder(getSetDisplayPlaceholder());
    }, [defaultValue]);
    const onChangeSelect = useCallback((e) => {
        const newValue = e.target.value;
        onChange(e, newValue);
        setValue(newValue);
        if (newValue == placeholderValue) {
            setDisplayPlaceholder(true);
        }
        else {
            setDisplayPlaceholder(false);
        }
    }, [onChange]);
    function getSetDisplayPlaceholder() {
        return !defaultValue || defaultValue == placeholderValue;
    }
    const name = `${Math.random()}`;
    return (React.createElement(FormControl, { className: css(styles.container, containerClassObject) },
        label && (React.createElement("div", { className: css(styles.label) },
            label,
            required && React.createElement(RequiredBadge, null))),
        React.createElement(MuiSelect, { variant: "standard", IconComponent: displayIcon ? SelectArrowIcon : noneIcon, labelId: "select-label-id", value: value, label: label, required: required, onChange: onChangeSelect, input: React.createElement(BootstrapInput, null), inputProps: { name, id: `select-${name}` }, MenuProps: {
                classes: {
                    paper: css(listClassObject),
                },
            }, classes: {
                root: displayPlaceholder ? css(styles.root, styles.placeholder) : css(styles.root),
                select: css(styles.select, selectClassObject, hasValidationError && styles.validationError),
            }, displayEmpty: true }, selectOptions.map((data, i) => {
            if (!!placeholder && data.value == placeholderValue) {
                return (React.createElement(MenuItem, { key: i, value: data.value, className: css(styles.placeholder, listItemClassObject) }, placeholder));
            }
            else {
                return (React.createElement(MenuItem, { key: i, value: data.value, className: css(listItemClassObject) }, data.name));
            }
        })),
        unitLabel && React.createElement("div", { className: css(styles.unitLabel) }, unitLabel),
        validationErrorMessage && React.createElement("div", { className: css(styles.validationErrorMessage) }, validationErrorMessage)));
};
const SelectArrowIcon = () => {
    return React.createElement(ArrowIcon, { classObject: styles.arrowIcon, color: Colors.GrayDarkestB, direction: ArrowDirection.bottom });
};
const noneIcon = () => {
    return React.createElement("div", null);
};
const styles = StyleSheet.create({
    arrowIcon: {
        width: 12,
        position: 'absolute',
        right: 16,
        transition: '0s',
    },
    container: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        flexDirection: 'row',
    },
    label: {
        display: 'flex',
        alignItems: 'center',
        gap: 8,
        fontSize: 14,
        color: Colors.GrayDarkest,
        marginBottom: 8,
    },
    root: {
        width: '100%',
    },
    placeholder: {
        color: Colors.GrayDarkest,
    },
    select: {
        padding: 12,
        border: `1px solid ${Colors.Gray}`,
        ':focus': {
            boxShadow: `0 0 10px -5px ${Colors.Primary}`,
            borderColor: Colors.Primary,
        },
    },
    unitLabel: {
        color: Colors.GrayDarkest,
        position: 'absolute',
        right: 12,
        fontSize: 16,
        fontWeight: 400,
        lineHeight: '160%',
        letterSpacing: 1.28,
    },
    validationError: {
        ':focus': {
            border: `1px solid ${Colors.Alert}`,
        },
        border: `1px solid ${Colors.Alert}`,
    },
    validationErrorMessage: {
        marginTop: 4,
        color: Colors.Alert,
        fontSize: 12,
        fontWeight: 400,
        lineHeight: '160%',
        letterSpacing: 0.48,
    },
});
